import { Box, LinearProgress, linearProgressClasses, styled } from "@mui/material";
import { FC } from "react";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 5,
  borderRadius: 5,
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
  },
}));

const GenericLoader: FC<{}> = () => {
  return (
    <Box
      sx={{
        minHeight: "100%",
        width: "100%",
        zIndex: 9,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: '100%', minHeight: "100%" }}>
        <BorderLinearProgress color="secondary" />
      </Box>
    </Box>
  );
};

export default GenericLoader;
